export const API_URL = process.env.REACT_APP_API_URL;

const API = {
  ADMIN_SERVICE: {
    BASE: '/admin',
    DASHBOARD: '/dashboard_counter',
    INVITATION: '/admin/invitation',
    USERS: '/admin/users',
  },
  FONT_SERVICE: {
    BASE: 'https://www.googleapis.com',
    WEBFONTS_V1: '/webfonts/v1/webfonts',
  },
  AUTH_SERVICE: {
    BASE: '/users',
    SIGN_IN: '/users/sign_in',
    PASSWORD: '/users/password',
  },
  BEER_STYLES_SERVICE: {
    BASE: '/beer_styles',
  },
  BEERS_SERVICE: {
    BASE: '/beers',
    ADMIN_BEERS: '/admin/beers',
    TOP_BEERS: '/dashboard_top_beers',
  },
  BREWERIES_SERVICE: {
    BASE: '/breweries',
    TOP_BREWERIES: '/dashboard_top_breweries',
  },
  POSTS_SERVICE: {
    BASE: '/posts',
  },
  PAGE_EDITORS_SERVICE: {
    BASE: '/assigned_editors',
  },
  PUB_SERVICE: {
    BASE: '/pubs',
  },
  ACTIVE_STORAGE: `${API_URL}/rails/active_storage/direct_uploads`,
  BACKGROUND: {
    CREATE_DEFAULT: '/default_backgrounds',
  },
};

export default API;
